__turbopack_context__.v({
  "activeTab": "Tabs-module__nXYAca__activeTab",
  "label": "Tabs-module__nXYAca__label",
  "labelGhost": "Tabs-module__nXYAca__labelGhost",
  "labelVisible": "Tabs-module__nXYAca__labelVisible",
  "tab": "Tabs-module__nXYAca__tab",
  "tabList": "Tabs-module__nXYAca__tabList",
});
